import { IDs } from '../../../helpers/IDs';
import { getKennzahlenVerfuegbar } from '../../../main/functions/getKennzahlenVerfuegbar';

export function getFilteredKennzahlen(jahr: number, data: any, showAll: boolean) {
    const kennzahlen = data[IDs.ENT_KENNZAHLEN_DEFINTION];
    const kennzahlen_berechnet = { ...data[IDs.KENNZIFFERN_BERECHNET] };
    const kz_verfuegbar = getKennzahlenVerfuegbar(kennzahlen_berechnet, jahr);
    const mapSeen: any = {};
    const kennzahlen_sorted = kennzahlen.filter((k: any) => {
        const seen = mapSeen[k.kuerzel];
        mapSeen[k.kuerzel] = true;
        // console.log('KENN_FILTER', k, kz_verfuegbar);
        return !seen && (showAll || (k.is_berechnet && k.is_berechnet === 1) && kz_verfuegbar[k.kuerzel]);
    }).sort((a: any, b: any) => a.name > b.name);
    return kennzahlen_sorted;
}
